(function () {
    angular.module('tmx-app')
        .controller('dayEndManagementCtrl', ['resolvedData','menu', 'tmxResource', 'TmxDialogService','ToastService','$state','tmxUtility', 

            function DayEndManagementCtrl(resolvedData,menu, tmxResource, TmxDialogService,ToastService,$state,tmxUtility) {

                var dayEndManagementVM = this;
                var showConfirmDialog = TmxDialogService.showConfirmDialog;
                dayEndManagementVM.menu=menu;

        //Resolved Data
                var allActiveProcesses = resolvedData.allActiveProcesses.data;
                var dayEndHistory = resolvedData.getDayendHistory.data;


        //making a new VM for table
                dayEndManagementVM.processTable = allActiveProcesses.map(process => {                    
                    var filtereddayEndHistory = dayEndHistory.filter(x => (x.DayendProcessId == process.DayendProcessId));
                    return {
                        ProcessCode: process.ProcessCode,
                        ProcessName: process.ProcessName,
                        IsActive: process.IsActive ? 'Yes' : 'No',
                        ExecutionDate: filtereddayEndHistory.length > 0 ? tmxUtility.formatDateTimeForCompany(filtereddayEndHistory[0].ExecutionDate) : null,
                        IsSuccess: filtereddayEndHistory.length > 0 ? filtereddayEndHistory[0].IsSuccess ? 'Yes' : 'No' : null
                    }
                });


        //Execute Single Row
                dayEndManagementVM.executeRow = function (processCode) {

                    dayEndManagementVM.selectedProcessCode = processCode;

                    showConfirmDialog("Confirmation", "Are you sure you want to Execute the Command", function ExecuteDayendProcess() {

                        tmxResource('DayEnd').getByAction('ExecuteDayendProcess/' + dayEndManagementVM.selectedProcessCode, true, 'get').then(function (response) {

                            if(response && response.status.code == 200){
                                ToastService.showCustomToast("success", "Command Executed Successfully");
                                $state.reload();
                            }
                            else
                                ToastService.showCustomToast("error", "Command Execution Failed");
                        })
                    });
                }

        //Execute all row
                dayEndManagementVM.executeAll = function () {
                    showConfirmDialog("Confirmation", "Are you sure you want to Execute All Commands", function ExecuteDayend() {

                        tmxResource('DayEnd').getByAction('ExecuteDayend/', true, 'get').then(function (response) {

                            if(response && response.status.code == 200){
                                ToastService.showCustomToast("success", "All Commands Executed Successfully");
                                $state.reload();
                            }
                            else
                                ToastService.showCustomToast("error", "Command Execution Failed");
                        })
                    });
                }
            }]);
})();

